import { initDependencies, setupDependencies } from 'browser/app';
import { start } from './start';

setupDependencies();
initDependencies();

start();
